import classNames from "classnames";
import type { FC, ReactNode } from "react";
import {
  FloatingCard,
  IconButton,
  bgStyles,
  borderStyles,
  flexStyles,
  iconStyles,
  paddingStyles,
  positionStyles,
  textStyles,
  widthStyles,
} from "ui";

interface EditPopoverProps {
  isOpen: boolean;
  onOpen: () => void;
  editor: ReactNode;
  showEditButton?: boolean;
  floatingCardClassName?: string;
}

export const EditPopover: FC<EditPopoverProps> = ({
  isOpen,
  onOpen,
  editor,
  showEditButton = true,
  floatingCardClassName,
}) => {
  return (
    <div className={classNames(positionStyles.absolute, positionStyles.right050, positionStyles.top050)}>
      {showEditButton && (
        <IconButton
          square
          iconType="Edit"
          className={classNames(
            bgStyles.neutral0,
            borderStyles.neutral200,
            positionStyles.zIndex5,
            paddingStyles.p075,
            iconStyles.neutral600,
          )}
          onClick={onOpen}
        />
      )}
      {isOpen && (
        <FloatingCard
          className={classNames(
            positionStyles.zIndex47,
            paddingStyles.p075,
            textStyles.fontPoppins,
            textStyles.neutral600,
            widthStyles.min2000,
            flexStyles.vert050,
            floatingCardClassName,
          )}
        >
          {editor}
        </FloatingCard>
      )}
    </div>
  );
};
